import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReplyButtonProps {
  onClick: () => void;
}

const ReplyButton = ({ onClick }: ReplyButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-7 px-2 text-xs opacity-70 hover:opacity-100 transition-opacity"
    >
      <MessageSquare className="h-3 w-3 mr-1" />
      Reply
    </Button>
  );
};

export default ReplyButton;
